import { Button, Container, Dialog, Grid, Paper, Stack, Typography,Box } from '@mui/material';
import { FormProvider, TextField } from '../../../../../components';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getCurrentDateTime } from '../../../../../utils';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { RegistrationRegisterReport } from '../../../../Print/options/Hospital/HMS/RegistrationRegisterReport';
import { SaveAs } from '@mui/icons-material';
import * as XLSX from 'xlsx';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';


const validationSchema = Yup.object().shape({
  from_date: Yup.string().required('From date is required'),
  to_date: Yup.string().required('To date is required')
});

export const RegistrationRegister = () => {
  const { pathname } = useLocation();
  const [openPrint, setOpenPrint] = useState(false);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      from_date: new Date().toISOString().split('T')[0],
      to_date: new Date().toISOString().split('T')[0],
    },
    mode: 'all'
  });

  const { watch } = methods;
  
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

const handleExcelReport = async () => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtention ='.xlsx';
  const respone = await axios.get(`${BASE_URL}/print/hospital/outpatient-management/registration-register?refId={"from_date":"${watch('from_date')}","to_date":"${watch('to_date')}"}`)
  
  if (respone.data.success) {
    const filteredData = respone.data.data.opdData.data;
    if (filteredData.length > 0) {
      console.log(filteredData);
      const fileName = `Registration_Register_Report_${watch('from_date')}_to_${watch('to_date')}`;

      const formattedData = filteredData.map((item, index) => ({
        "Sr. No.": index + 1,
        'Bill Date': formatDate(item?.date),
        'Uhid No.': item?.uhid,
        'Patient Name': (`${item?.name_suffix} ${item.first_name} ${item.last_name}`),
        'Address': item?.address?.address,
        'City': item?.city?.city,
        'State': item?.state?.state,
        'Category': item?.sponsor?.name,
        'Mobile No': item?.address?.mobile,
        'Refer By': item?.ref_by,
        'Entry By': item?.createdBy
      }));
      const ws = XLSX.utils.json_to_sheet(formattedData);
      const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const data = new Blob([excelBuffer], { type: fileType });
      saveAs(data, fileName + fileExtention);
    } else {
      toast(`No Data Found For These Filter`, { variant: 'error' });
    }
  } else {
    toast(`Something Went Wrong`, { variant:'error' });
  }
};

  return (
    <>
      <Paper sx={{
        p: 0, flex: 1, borderRadius: 0, boxShadow: 'none',
        width: '100%',
        height: 'auto'
      }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: "100%",
            boxSizing: 'border-box',
          }}
        >
          <FormProvider methods={methods}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Registration Register Report
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button
                  variant="contained"
                  disabled={!watch('from_date') || !watch('to_date')}
                  onClick={() =>
                    window.open(
                      `/print${pathname}?refId=${JSON.stringify({
                        from_date: watch('from_date'),
                        to_date: watch('to_date')
                      })}`,
                      '_blank'
                    )
                  }
                >
                  View Pdf Report
                </Button>
                <Button
                  variant="contained"
                  disabled={!watch('from_date') || !watch('to_date')}
                  onClick={handleExcelReport}
                >
                  View Excel Report
                </Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box sx={{ border: '0px solid gray', padding: 2, borderRadius: '8px', width: '60%', boxShadow: '0px 2px 10px #0099ff' }}>
            <Grid container spacing={2}>
              <Grid item xs={6} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>From Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="from_date" type="date" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>To Date</Typography>
                  <TextField sx={{ flex: 0.8 }} name="to_date" type="date" />
                </Stack>
              </Grid>
            </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openPrint}
        onClose={() => setOpenPrint(false)}
        PaperProps={{ sx: { width: '80%', height: '85%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <RegistrationRegisterReport />
      </Dialog>
    </>
  );
};

export default RegistrationRegister;
